module.exports = __webpack_public_path__ + "img/yinxian.b0f285b5.gif";